class ::Signal
  def self.trap(*)
  end
end

class ::GC
  def self.start
  end
end
